module.exports = __webpack_public_path__ + "static/media/DG-3.06083aaf.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/wbstdt/imgs/services/DG-3.jpg
// module id = 98
// module chunks = 0